import React from "react";
import { isServer } from "../../../utils";
import { KeysEnum } from "../../models/Enums";
import { vfOpenIDConnect } from "./ViafouraIDConnect";
import "./Viafoura.css";

type ViafouraProps = {};

export class ViafouraComponent extends React.Component<ViafouraProps> {
  viafouraCommentsModel = {
    replyLimit: 2,
    sort: "newest",
    paginationLimit: 10,
    articlePagePath: "",
    aarpId: "",
    customContainerId: "",
    limit: 10,
    paginationReplyLimit: 10,
    featuredTabActiveThreshold: 3,
  };

  async componentDidMount() {
    if (!isServer) {
      await this.init();
      await this.initAuth();
    }
  }

  async componentDidUpdate() {
    if (!isServer) {
      let wnd = window as any;
      if (wnd.vf && wnd.vf.context) {
        wnd.vfQ = wnd.vfQ || [];
        wnd.vfQ.push(() => {
          wnd.vf.context.reset();
        });
      }
    }
  }

  async init() {
    let script = document.createElement("script");
    script.src = window.location.protocol + "//cdn.viafoura.net/entry/index.js";
    script.async = true;
    script.type = "text/javascript";
    document.body.appendChild(script);
    script.onload = () => {
      window.dispatchEvent(new CustomEvent("VIAFOURA_JS_LOADED"));
    };
  }

  async initAuth() {
    const idToken = localStorage.getItem(KeysEnum.idToken);
    const authenticateViafoura = () => {
      vfOpenIDConnect({
        idToken,
      });

      window.addEventListener("VIAFOURA_LOGOUT", () => {
        if ((window as any).vf && (window as any).vf.session) {
          (window as any).vf.session.logout();
        }
      });
      (window as any).vf.$subscribe(
        "login",
        "failure",
        function (errorContext, loginContext) {
          console.log("Viafoura login fail: ", errorContext, loginContext);
        }
      );
    };

    window.addEventListener("VIAFOURA_JS_LOADED", authenticateViafoura);
  }

  render() {
    return (
      <div
        id="my-comments"
        className="aarp-c-viafoura aarp-c-viafoura--aarpe-customized aarp-c-viafoura--aarpe-customized@tablet aarp-c-viafoura--aarpe-customized@mobile"
      >
        <div className="viafoura">
        <style>
            {`
              .viafoura {
                .vf-content-actions:not(.vf-content-actions--entered) {
                  .vf-content-actions__left-action.vf-content-actions__reply {
                    color: #0074e8 !important;
                  }
                }
              }
            `}
          </style>
          <vf-conversations
            limit={this.viafouraCommentsModel.replyLimit}
            pagination-limit={this.viafouraCommentsModel.paginationLimit}
            reply-limit={this.viafouraCommentsModel.replyLimit}
            pagination-reply-limit={
              this.viafouraCommentsModel.paginationReplyLimit
            }
            sort={this.viafouraCommentsModel.sort}
            featured-tab-active-threshold={
              this.viafouraCommentsModel.featuredTabActiveThreshold
            }
          ></vf-conversations>
          <div className="viafoura">
            <vf-tray class="vf-tray--modal-override"></vf-tray>
          </div>
        </div>
        <textarea className="progressive-comp-data" style={{ display: "none" }}>
          {{
            articlePagePath: `${this.viafouraCommentsModel.articlePagePath}`,
            aarpId: `${this.viafouraCommentsModel.aarpId}`,
            customContainerId: `${this.viafouraCommentsModel.customContainerId}`,
            limit: `${this.viafouraCommentsModel.limit}`,
            paginationLimit: `${this.viafouraCommentsModel.paginationLimit}`,
            replyLimit: `${this.viafouraCommentsModel.replyLimit}`,
            paginationReplyLimit: `${this.viafouraCommentsModel.paginationReplyLimit}`,
            sort: `${this.viafouraCommentsModel.sort}`,
            featuredTabActiveThreshold: `${this.viafouraCommentsModel.featuredTabActiveThreshold}`,
          }}
        </textarea>
      </div>
    );
  }
}
